<script>
import _ from 'lodash'

import ReferenceRangeChart from '../globals/ReferenceRangeChart'

import generateURL from '../../utils/generateURL'
import {
  getRange,
  getColor,
  getLink,
  getDefaultUnit
} from '../../utils/biomarker'

export default {
  name: 'TimelineItemInner',
  components: { ReferenceRangeChart },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    getType() {
      return this.item.range.type + ''
    },
    getRange() {
      return getRange(this.item)
    },
    getColor() {
      const { range, quantity, text } = this.item
      const item = { biomarker: { range }, quantity, text }
      return getColor(item, this.getRange)
    },
    getLink() {
      return getLink(this.item.range)
    },
    getDefaultUnit() {
      return getDefaultUnit(this.item)
    }
  },
  methods: {
    generateURL
  }
}
</script>

<template>
  <div v-if="item" class="result">
    <div class="columns is-multiline is-mobile">
      <div class="column is-4-tablet is-7-mobile">
        <router-link
          :to="{
            name: 'BiomarkerView',
            params: { id: generateURL(item) }
          }"
          class="has-text-secondary"
        >
          <span class="timeline-item-inner--name">
            {{ item.name }}
          </span>
        </router-link>
      </div>
      <div class="column">
        <div class="container has-text-right-mobile">
          <span
            v-if="item.text"
            class="timeline-item-inner--text"
            :style="{ color: getColor }"
          >
            {{ item.text }}
          </span>
          <span
            v-if="item.quantity"
            class="timeline-item-inner--quantity"
            :style="{ color: getColor }"
          >
            {{ item.quantity }}
          </span>
          <span
            v-if="getDefaultUnit"
            class="timeline-item-inner--unit"
            :style="{ color: getColor }"
          >
            {{ getDefaultUnit }}
          </span>
        </div>
      </div>
      <div class="column is-5-tablet is-12-mobile is-clipped">
        <ReferenceRangeChart
          v-if="getType === 'universal' || getType === 'gender'"
          :range="getRange"
          :result="item.quantity"
        />
        <div v-if="getLink" class="timeline-item-inner--link">
          <a
            class="button is-light has-text-tertiary is-fullwidth"
            :href="getLink.url"
            target="_blank"
            >{{ getLink.anchor }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="sass">
.column
  height: 59px
  line-height: 35px

.result
  background: #fff
  border: none
  box-shadow: none
  border-radius: 5px
  padding: 6px 15px
  margin: 8px 0
  font-size: 18px

.timeline-item-inner
  &--name, &--text, &--quantity
    font-weight: 500
  &--unit
    margin-left: 4px
    font-weight: 100
</style>
